import AuthToken from './AuthToken'
import GetProducts from './GetProducts'
import LocalStorage from './LocalStorage'
import SessionStorage from './SessionStorage'
import User from './User'
import Report from './Report'

export const AuthTokenService = AuthToken
export const GetProductsService = GetProducts
export const LocalStorageService = LocalStorage
export const SessionStorageService = SessionStorage
export const UserService = User
export const ReportService = Report
